import { i18n } from '../i18n'
import axios from 'axios'

export default {
  namespaced: true,

  state: {
    locale: process.env.VUE_APP_I18N_LOCALE || 'en'
  },

  getters: {
    locale: (state) => state.locale
  },

  mutations: {

  },

  actions: {
    setLocale ({ state }, locale) {
      state.locale = locale
      localStorage.setItem('locale', locale)
      i18n.global.locale = locale
      axios.defaults.headers.common['Content-Language'] = locale
    }
  }
}
